import {createInputImageUploadUrl, createVectorizationPresets, restartVectorization} from "../../api/vectorization";
import aws_config from "../../modified_aws-export";
import {Amplify, Storage} from "aws-amplify";
import {ICreateVectorizationPresetsRequest} from "../../types/vectorization";
import {ToastError} from "../../utils/toastUtil";


export const startVectorizationProcess = async (file: File, selectedPresets: number[]) => {
    Amplify.configure(aws_config);
    try {
        const createInputImageUpload = await createInputImageUploadUrl();
        await Storage.put(createInputImageUpload.input_file_key, file, {
            contentType: file.type,
            bucket: aws_config.vectorization_images_s3_bucket_name,
            customPrefix: {public: ""},
        });
        return await createVectorizationPresets({
            file_name: file.name.replace("image_similarity_search/", ""),
            input_file_key: createInputImageUpload.input_file_key,
            presets: selectedPresets
        } as ICreateVectorizationPresetsRequest);
    } catch (error) {
        console.error(`startVectorizationProcess ${error}`);
        ToastError(error as string);
    }
}

export const restartVectorizationProcess = async (id: string, key: string, fileName: string) => {
    try {
        await restartVectorization(id, key, fileName);
    } catch (error) {
        console.error(`refreshVectorizationProcess ${error}`);
        ToastError(error as string);
    }
}